module.exports = __webpack_public_path__ + "img/water02_selected.ce24c773.png";